import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 44 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ index, label, title, testid }) {
  return (
    <Reveal>
      <p className="font-mono text-xs tracking-[0.3em] uppercase text-zinc-500 mb-4">
        <span className="text-[#007AFF]">{index}</span> / {label}
      </p>
      <h2 className="font-display font-bold tracking-tight text-3xl md:text-4xl lg:text-5xl" data-testid={testid}>
        {title}
      </h2>
    </Reveal>
  );
}
